/* Lunora: paketen läggs i kassan som N st av "1 tube" i stället för 1 st av paketvarianten,
   så att ordern visar rätt antal tuber. Rabatten kommer från de automatiska rabatterna
   "Kjøp 2 – få 1 gratis" och "Kjøp 3 – få 2 gratis" i Shopify. */
(function () {
  var TUBE = '59244016238966';
  var PAKKER = { '59244016271734': 3, '59244016304502': 5 };
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action$="/cart/add"]')) return;
    var id = form.querySelector('input[name="id"]');
    if (!id || !PAKKER[id.value]) return;
    var paket = id.value, antal = form.querySelector('input[name="quantity"]');
    if (!antal) {
      antal = document.createElement('input');
      antal.type = 'hidden'; antal.name = 'quantity'; antal.dataset.lunora = '1';
      form.appendChild(antal);
    }
    id.value = TUBE; antal.value = PAKKER[paket];
    // Temat läser formuläret synkront; återställ valet direkt efteråt.
    setTimeout(function () {
      if (id.value === TUBE) id.value = paket;
      if (antal.dataset.lunora) antal.remove();
    }, 0);
  }, true);
})();
